import type { FormJson } from "src/app/features/ApplicationConfigurations/types/AppConfigsTypes";
import type { AppConfigurationDto } from "src/app/features/ApplicationConfigurations/types/AppConfigurationDto";
import type { AppConfigurationEntity } from "src/app/features/ApplicationConfigurations/types/AppConfigurationEntity";

export const AppConfigurationDtoToEntity = (appConfigurationDto: AppConfigurationDto): AppConfigurationEntity => {
    const applicationConfiguration = JSON.parse(appConfigurationDto?.applicationConfiguration || "") as FormJson;
    return {
        applicationConfiguration,
    };
};
